import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Long-Term Side Effects/Risks';
const pageSubTitle = 'Long-Term Side Effects/Risks';
const videoKey = 'dTRyU4UhSkU';

const LongTermSideEffects = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <>
                    <p>
                        Long-Term Side Effects and Risks reflects how important it is to avoid problems that
                        may arise well after treatment. These include:
                        <br/>
                        <ul style={{ marginLeft: 16 }}>
                            <li>
                                Revision Risk Concern: the possibility of needing another procedure in the
                                future.
                            </li>
                            <li>
                                Tissue Degeneration Concern: potential damage to joints or surrounding
                                tissues.
                            </li>
                            <li>
                                Systemic Side Effects Concern: effects that could impact other parts of the
                                body.
                            </li>
                            <li>
                                Diminishing Effectiveness Concern: when a treatment loses its benefit over
                                time.
                            </li>
                        </ul>
                    </p>
                    <p>
                        Each of these concerns may matter more or less depending on the individual. Each
                        Each of these concerns may matter more or less depending on the individual. Each
                        treatment performs differently across these concerns. For example, Physical Therapy
                        tends to score well on <i>Tissue Degeneration Concern</i> because it supports joint
                        health without causing damage. In contrast, a treatment like Total Knee Replacement
                        may carry a higher risk of tissue damage during or after surgery, leading to a lower
                        score on this concern. This part of the decision is about identifying which
                        long-term risks are most important for you to avoid.
                    </p>
                </>
            }
            videoKey={videoKey}
            pageType="criteria"
        />
    );

};

export default LongTermSideEffects;